import { AnyNetworkElement, isAbgangsleitung, hasCoordinates } from '../../types/network';
import L from 'leaflet';

const isValidCoordinate = (lat: number, lng: number) => {
  return lat !== 0 && lng !== 0 && !isNaN(lat) && !isNaN(lng);
};

export const calculateMapBounds = (elements: AnyNetworkElement[]) => {
  const points: L.LatLng[] = [];
  const validElements = elements.filter(el =>
    (hasCoordinates(el) && isValidCoordinate(el.coordinates.lat, el.coordinates.lng)) ||
    isAbgangsleitung(el)
  );

  const batchSize = 100;
  for (let i = 0; i < validElements.length; i += batchSize) {
    const batch = validElements.slice(i, i + batchSize);

    batch.forEach((element: AnyNetworkElement) => {
      if (hasCoordinates(element) &&
          isValidCoordinate(element.coordinates.lat, element.coordinates.lng)) {
        points.push(L.latLng(element.coordinates.lat, element.coordinates.lng));
      }

      if (isAbgangsleitung(element)) {
        element.waypoints.forEach(wp => {
          if (wp && isValidCoordinate(wp.lat, wp.lng)) {
            points.push(L.latLng(wp.lat, wp.lng));
          }
        });
      }
    });
  }

  return points;
};
